var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as usersData } from '@web/lib/demo/data/users';
import { UserRole } from '@workalizer/db';
export var users = function () {
    return usersData
        .map(function (user) {
        var _a, _b;
        return (__assign(__assign({}, user), { orgUnit: (_b = (_a = user.userOrgUnits[0]) === null || _a === void 0 ? void 0 : _a.orgUnit) !== null && _b !== void 0 ? _b : null, role: user.role }));
    })
        .filter(function (user) {
        var _a;
        return user.role === UserRole.ADMIN ||
            ((_a = user.userOrgUnits) === null || _a === void 0 ? void 0 : _a.some(function (uou) { var _a; return (_a = uou.orgUnit) === null || _a === void 0 ? void 0 : _a.isActive; }));
    });
};
